export enum DevicePreviewStatus {
  Complete = 'Complete',
  Processing = 'Processing',
  Bounced = 'Bounced',
  Pending = 'Pending',
}

export interface DevicePreview {
  category: string;
  client: string;
  display_name: string;
  id: string;
  os: string;
  screenshots: { default: string };
  default: string;
  status: DevicePreviewStatus;
  thumbnail: string;
}
